/**
 * G2/K7 — Uyarilar blogunun esikleri TEK YERDE. Degistirmek kullanici karari (2026-09-13: 3 puan).
 * Olculen buyukluk (spec §2.4): Agustos Meyve ve Sebze −10,47 puan; ikinci en buyuk dusus −1,16.
 */
export const MARJ_ERIME_PUAN = 3;
